/** @format */
import React from "react";
import { Box, Grid, useTheme } from "@mui/material";
import { useUser } from "hooks";
import { ThemeOption } from "types";
import { useLocation } from "react-router-dom";
import Header from "pages/auth/components/Header";

interface MainLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { isLogged, mode } = useUser();
  const location = useLocation();
  const theme = useTheme() as ThemeOption;

  return (
    <Box
      padding={"15px"}
      maxHeight={"100vh"}
      display={"flex"}
      flexDirection={"column"}
      gap={"15px"}
    >
      {/* <Header /> */}
      <Box
        width={"100%"}
        height="calc(100vh - 106px)"
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Box
          height={"100%"}
          maxHeight="calc(100vh - 106px)"
          width={"calc(100vw - 45px)"}
          component={"main"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};
